// 账号密码登录
import { FC, useRef, useState } from 'react';
import cs from 'classnames';
import styles from './index.module.less';
import { Form, Button, Modal } from 'antd';
import { Link } from 'react-router-dom';
import IconFont from '@/common/components/Base/IconFont';
import V2FormInputPassword from '@/common/components/Form/V2FormInputPassword/V2FormInputPassword';
import V2Form from '@/common/components/Form/V2Form';
import V2FormInput from '@/common/components/Form/V2FormInput/V2FormInput';
import Agreement from './Agreement';
import { MOBILE_REG } from '@lhb/regexp';
import { get, post } from '@/common/request/index';
import { setCookie, setStorage } from '@lhb/cache';
import { ChangeModalStatus } from '../ts-config';
import QyWxLogin from './QyWxLogin';
import { useBigdataFn } from '@/common/utils/bigdata';
import { isObject, isArray } from '@lhb/func';
import { setValidTimeCookie } from '@/common/utils/ways';
import JSEncrypt from 'jsencrypt';
import { useMethods } from '@lhb/hook';
import { fetchLogin } from '@/common/api/login';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import GetCode from '@/common/components/business/GetCode';
const encrypt = new JSEncrypt();
encrypt.setPublicKey('MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAxqKWCHj4iL1SXJ6dPXiE1iGlYgaNqV5vj3tg44mVJCYkalgwcM6IRvSE0o9/wPF7fJ8TZ7B7/869Zrr6QHuNMOv1KysddjAr1eqa6AoTevH1O6Q0qzPxxON4niKyeBqmLcDnySTbPjq/KsENF5tOdd6GenpOdonzHu8xcLxqxAQcYq8QjPxk0o+GS4n/483cBl4XmzD9ROrSsME0ZMKU5Es/cY3FoPnCyfEfQm9SbeKnMSF3coVecfEsMzkEEJKM12cax2Sd6U3P57swFzoxedAZwZ3LkfPTSnOWT5XdF2zU3qMRB1DeRpwoR0vzy+Cpzxb0GKJafmYHNJoJTslq6QIDAQAB');
const pstRule = { pattern: /^.{8,16}$/, message: '请输入8-16位密码' };
const passWordPrefix = (
  <p className={cs(styles.passwordTips, 'color-primary-operate')}>
    <Link to='/password'>忘记密码</Link>
  </p>
);

const AccountLogin: FC<ChangeModalStatus> = ({ setShowAccountModal, setModalVisible, setInfoData, form,
  isAutoRegister,
  setIsShareConfigToLogin,
}) => {
  const [levelData, setLevelData] = useState<any>({
    visible: false,
    mobile: null,
  });
  const [levelForm] = Form.useForm();
  const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const lockRef: any = useRef(false);

  const [open, setOpen] = useState<boolean>(false);

  const methods = useMethods({
    async onOk() { // 管理员登录
      const values = levelForm.getFieldsValue();
      if (!values.code) {
        V2Message.warning('请输入验证码');
        return;
      }
      lockRef.current = true;
      await fetchLogin({
        code: values.code,
        mobile: levelData.mobile,
      }).then((data) => {
        const { token, accountId } = data;
        if (token) {
          setStorage('flowLoginToken', token);
          setCookie('flow_account_id', accountId);
          setShowAccountModal(true);
          setLevelData({
            visible: false,
            mobile: null,
          });
        }
      }).finally(() => {
        // 这里加延时是因为setShowAccountModal的逻辑导致的，显示弹窗过程时，内部组件又有一个异步的逻辑，导致弹窗还未弹出时，按钮依然可以点击到
        setTimeout(() => {
          lockRef.current = false;
        }, 250);
      });
    },
    async getCheckAdmin(mobile) {
      return new Promise((resolve) => {
        if (MOBILE_REG.test(mobile)) {
          get('/checkAdmin', { mobile }).then((res) => {
            resolve(res.data);
          }, () => {
            resolve(false);
          });
        } else {
          resolve(false);
        }
      });
    },
  });

  const handleOk = () => {
    const values = form.getFieldsValue();
    handleLogin(values);
    setOpen(false);
  };

  // 信息填写完成填入cookie跳转到首页
  const onFinish = async (values: any) => {
    // if (!values.agree) {
    //   message.warning('请先勾选Location《保密协议》、《服务条款》、《隐私政策》');
    //   return;
    // }
    const { agree } = values || {};
    // 未勾选时，agree 是undefined，勾选后再取消勾选是Array
    if (!agree || (isArray(agree) && agree.length === 0)) {
      // message.warning('请先勾选Location《保密协议》、《服务条款》、《隐私政策》');
      setOpen(true);
      return;
    }
    handleLogin(values);
  };

  const handleLogin = async(values) => {
    // // https://yapi.lanhanba.com/project/94/interface/api/12382
    const params = { ...values, passwordEncrypted: true, password: encrypt.encrypt(values.password) };
    // 是否需要选择企业
    let isNeedChooseAccount: boolean = false;
    // 如果是手机号入参为mobile
    if (MOBILE_REG.test(values.username)) {
      params.mobile = values.username;
      delete params.username;
      isNeedChooseAccount = true;
    }
    if (lockRef.current) return;
    lockRef.current = true;
    await post('/login', { ...params }, { needHint: true,
      // isMock: true, mockId: 297, mockSuffix: '/api'
    }).then(async (res) => {
      // bigdataFn('42851518-803b-4a7e-bc8a-bad9c78ec6c9', '登录按钮', '点击了登录');
      // if代码块的逻辑废弃了，0815版本没有了试用账号注册的逻辑了
      if (res?.errCode === 'DE0519999601') {
        setInfoData({
          visible: true,
          mobile: params.mobile
        });
      } else if (res?.errCode === 'DE0519999602') { // 试用到期
        setModalVisible(true);
      } else {
        const { token, accountId,
          tenantId,
          employeeId,
        } = res;
        if (!token) return;

        const needCheck = await methods.getCheckAdmin(values.username);
        if (needCheck) {
          setLevelData({
            visible: true,
            mobile: values.username,
          });
        } else {
          tenantId && setCookie('tenantId', tenantId);
          employeeId && setCookie('employeeId', employeeId);
          setCookie('flow_account_id', accountId);
          if (isNeedChooseAccount) {
            setStorage('flowLoginToken', token);
            // saas运营后台分享配置的链接登录的场景,直接选中租户
            if (isAutoRegister?.tenantId) {
              setIsShareConfigToLogin({
                ...res,
                id: isAutoRegister.tenantId
              });
              return;
            }
            setShowAccountModal(true);
          } else {
            let timeWait = 100;
            if (process.env.NODE_ENV !== 'development') { // 开发环境屏蔽
              if (isObject(token)) { // 如果是对象，就上报
              // 主动send事件
                window.LHBbigdata.send({
                  event_id: 'console_pc_cookie_monitoring_token', // 事件id
                  msg: res, // 额外需要插入的业务信息
                });
                timeWait = 200;
              }
            }
            setValidTimeCookie('flow_token', token);
            setTimeout(() => {
              window.location.reload();
              bigdataFn('42851518-803b-4a7e-bc8a-bad9c78ec6c9', '登录按钮', '点击了登录');
            }, timeWait);
          }
          // 这里加延时是因为setShowAccountModal的逻辑导致的，显示弹窗过程时，内部组件又有一个异步的逻辑，导致弹窗还未弹出时，按钮依然可以点击到
          setTimeout(() => {
            lockRef.current = false;
          }, 250);
        }
      }
    }, () => {
      // 这里加延时是因为setShowAccountModal的逻辑导致的，显示弹窗过程时，内部组件又有一个异步的逻辑，导致弹窗还未弹出时，按钮依然可以点击到
      setTimeout(() => {
        lockRef.current = false;
      }, 250);
    });
  };

  return (
    <div className={styles.AccountLogin}>
      <V2Form form={form} validateTrigger={['onChange', 'onBlur']} onFinish={onFinish} size='large'>
        <V2FormInput
          name='username'
          removeSpace
          maxLength={30}
          prefix={<IconFont className={styles.icon} iconHref='iconic_account' />}
          rules={[{ required: true, message: '请输入用户名' }]}
          config={{ autoComplete: 'on' }}
          placeholder='请输入手机号或用户名@企业简称'
        />
        {/* <p className={styles.usernameTips}>
          <IconFont className={styles.icon} iconHref='icon-warning_o' />
          员工账号规则为：手机号或用户名@企业简称
        </p> */}
        <V2FormInputPassword
          name='password'
          rules={[{ required: true, message: '请输入密码' }, pstRule]}
          placeholder='请输入密码'
          config={{ maxLength: 16 }}
          formItemConfig={{ className: 'mb-16' }}
          prefix={<IconFont className={styles.icon} iconHref='iconic_password' />}
        />
        {passWordPrefix}
        <Form.Item>
          <Button type='primary' htmlType='submit' block className={styles.submitBtn}>
            登录
          </Button>
        </Form.Item>
        <Agreement/>
        <QyWxLogin
          setShowAccountModal={setShowAccountModal}
        />
      </V2Form>

      <Modal
        title='提示'
        okText='同意并登录'
        open={open}
        onOk={handleOk}
        onCancel={() => setOpen(false)}
      >
        <p>
          <IconFont iconHref={'iconwarning-circle1'} className='c-ff8 mr-8'/>
          登录前，请先阅读并同意
          <Link to='/openweb/service' className={styles.agreeBtn}>《用户协议》</Link>
          与
          <Link to='/openweb/privacy' className={styles.agreeBtn}>《隐私政策》</Link>
        </p>
      </Modal>
      <Modal
        open={levelData.visible}
        width={448}
        centered={true}
        title='验证手机号'
        className={styles.levelModal}
        wrapClassName={styles.levelModalPop}
        okText='提交验证'
        onCancel={() => {
          setLevelData({
            visible: false,
            mobile: null,
          });
        }}
        onOk={methods.onOk}
      >
        <V2Form form={levelForm}>
          <div className={styles.levelModalTip}>
            <IconFont className={styles.levelModalTipIcon} iconHref='iconxq_ic_baocuo_normal' />
            <div className={styles.levelModalTipText}>
              您的账号开启了手机验证，请输入验证码进行验证
            </div>
          </div>
          <div className={styles.levelModalMobile}>
            手机号：{levelData.mobile}
          </div>
          <V2FormInput
            name='code'
            rules={[{ required: true, message: '请输入验证码' }]}
            placeholder='请输入验证码'
            maxLength={6}
            config={{
              suffix: <GetCode
                form={levelForm}
                isSimple={false}
                customMobile={levelData.mobile}
              />,
              className: styles.inputStyle,
            }}
          />
        </V2Form>
      </Modal>
    </div>
  );
};

export default AccountLogin;
